import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl;

export const fetchQuotations = createAsyncThunk(
  'hourlyRateQuotation/fetchAll',
  async (_, thunkAPI) => {
    try {
      const res = await axiosInstance.get(`${BackendURL}/hourlyratequotation`);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const createQuotation = createAsyncThunk(
  'hourlyRateQuotation/create',
  async (data, thunkAPI) => {
    try {
      const res = await axiosInstance.post(`${BackendURL}/hourlyratequotation/create`, data);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const updateQuotation = createAsyncThunk(
  'hourlyRateQuotation/update',
  async (data, thunkAPI) => {
    try {
      const res = await axiosInstance.put(`${BackendURL}/hourlyratequotation/update`, data);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const deleteQuotation = createAsyncThunk(
  'hourlyRateQuotation/delete',
  async (id, thunkAPI) => {
    try {
      await axiosInstance.delete(`${BackendURL}/hourlyratequotation/delete/${id}`);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const hourlyRateQuotationSlice = createSlice({
  name: 'hourlyRateQuotation',
  initialState: {
    quotations: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

    .addCase(fetchQuotations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQuotations.fulfilled, (state, action) => {
        state.loading = false;
        state.quotations = action.payload;
      })
      .addCase(fetchQuotations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createQuotation.fulfilled, (state, action) => {
        state.quotations.unshift(action.payload);
      })
      .addCase(createQuotation.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(updateQuotation.fulfilled, (state, action) => {
        const index = state.quotations.findIndex(q => q._id === action.payload._id);
        if (index !== -1) state.quotations[index] = action.payload;
      })
      .addCase(updateQuotation.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(deleteQuotation.fulfilled, (state, action) => {
        state.quotations = state.quotations.filter(q => q._id !== action.payload);
      })
      .addCase(deleteQuotation.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default hourlyRateQuotationSlice.reducer;
